<router-outlet />
<app-server-error-modal testIdScope="onb-app" />
<app-feedback-modal testIdScope="onb-app" />
@if (loader.visible()) {
  <app-loading-spinner variant="overlay" [label]="loader.label()" />
}
<app-footer />
